<template>
	<v-progress-linear @click="jumpTo($event)" v-if="video.isLoaded" id="video-progress" :value="videoProgress" background-color="var(--primary)" background-opacity="0.2"></v-progress-linear>
</template>
<script>
import {mapState} from "vuex";

export default {
	computed: {
		...mapState("UI", ["video"]),
		videoProgress() {
			let currentTime = this.video.currentTimeMs;
			let duration = this.video.durationMs;
			return currentTime / duration * 100;
		}
	},

	methods: {
		jumpTo(e) {
			let video = document.querySelector("#video");
			let pos = e.offsetX /  e.target.offsetWidth;
			// var pos = (e.pageX  - (this.offsetLeft + this.offsetParent.offsetLeft)) / this.offsetWidth;
			video.currentTime =  pos * this.video.durationMs;
		}
	},
};
</script>

<style lang="scss">
#video-progress {
	position: absolute;
	bottom: -4px;
	cursor: pointer;
}
</style>
